import React, { useContext, useState } from "react";
import {RouteComponentProps, withRouter} from "react-router";
import {NavLink} from "react-router-dom";
import {ReactComponent as DetailsIcon} from "../../../statics/icons/icon_orderDetails.svg";
import {ReactComponent as GoBackIcon} from "../../../statics/icons/icon_goBack.svg";
import {ReactComponent as MessagesIcon} from "../../../statics/icons/icon_notifications.svg";
import {ReactComponent as TcrIcon} from "../../../statics/icons/icon_tcr.svg";
import {ReactComponent as StatusIcon} from "../../../statics/icons/icon_status.svg";
import {ReactComponent as PhotosIcon} from "../../../statics/icons/icon_photos.svg";
import Button from "../../../common/components/shared/button/button";
import {ListItemButton, ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import {routingAddresses} from "../../../helpers/routing";
import i18n from "../../../i18n/i18n";
import {storesContext} from "../../../common/stores/stores";
import RoutingUtils from "../../../helpers/routingUtils";
import {RelationType} from "../../models/relation";
import TransportUtils from "../../../helpers/transportUtils";
import PopperMenu from "../../../common/components/shared/popperMenu/popperMenu";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuButton from "@mui/material/Button";
import {Utils} from "../../../helpers/utils";
import "./transportationActions.scss";

interface TransportationActionsProps extends RouteComponentProps {
    orderId: string;
    element: "ticket" | "order";
    relationType?: RelationType | "";
}

function TransportationActions(props: TransportationActionsProps): JSX.Element {
    const userStore = useContext(storesContext).userStore;
    const [openMenu, setOpenMenu] = useState<boolean>(false);
    const anchorRefUserMenu = React.useRef<HTMLButtonElement>(null);

    const isTicket = props.element === "ticket";
    const goBackAddress = isTicket ? routingAddresses.ticket.list : routingAddresses.order.list;
    const detailAddress = isTicket ? routingAddresses.ticket.details : routingAddresses.order.details;
    const notificationAddress = isTicket ? routingAddresses.ticket.notifications : routingAddresses.order.notifications;

    const orderGoBackText=`${i18n.t("transportation.order.preview.actions.goBack")}`;
    const orderDetailsText=`${i18n.t("transportation.order.preview.actions.details")}`;
    const ticketGoBackText=`${i18n.t("transportation.ticket.preview.actions.goBack")}`;
    const ticketDetailsText=`${i18n.t("transportation.ticket.preview.actions.details")}`;

    const className = `transportation-${props.element}`;

    const isRelationTypeWithoutDepo = TransportUtils.isRelationTypeWithoutDepo(props.relationType);
    const isTablet = Utils.isTabletOrMobile();

    function renderStatusMenu() {
        return(
            <NavLink
                exact
                to={`${routingAddresses.order.status}/${props.orderId}`}
                data-testid="status"
                className={isActive => `action-item ${isActive ? "active-item" : ""}`}
            >
                <ListItemButton>
                    <ListItemIcon className="item-icon">
                        <StatusIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={i18n.t("transportation.order.preview.actions.status")}
                        className="item-text"
                    />
                </ListItemButton>
            </NavLink>
        );
    }

    function renderDetailsMenu() {
        return(
            <NavLink
                exact
                to={`${detailAddress}/${props.orderId}`}
                data-testid="details"
                className={isActive => `action-item ${isActive ? "active-item" : ""}`}
            >
                <ListItemButton>
                    <ListItemIcon className="item-icon">
                        <DetailsIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={isTicket ? ticketDetailsText : orderDetailsText}
                        className="item-text"
                    />
                </ListItemButton>
            </NavLink>
        );
    }

    function renderMessagesMenu() {
        return(
            <NavLink
                exact
                to={`${notificationAddress}/${props.orderId}`}
                data-testid="notifications"
                className={isActive => `action-item ${isActive ? "active-item" : ""}`}
            >
                <ListItemButton>
                    <ListItemIcon className="item-icon">
                        <MessagesIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={i18n.t("transportation.notificationTile")}
                        className="item-text"
                    />
                </ListItemButton>
            </NavLink>
        );
    }

    function renderTcrMenu() {
        return(
            <NavLink
                exact
                to={RoutingUtils.getTcrAddress(userStore, props.orderId)}
                data-testid="tcr"
                className={isActive => `action-item ${isActive ? "active-item" : ""}`}
            >
                <ListItemButton>
                    <ListItemIcon className="item-icon">
                        <TcrIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={i18n.t("transportation.tcrTile")}
                        className="item-text"
                    />
                </ListItemButton>
            </NavLink>
        );
    }

    function renderPhotosMenu() {
        return(
            <NavLink
                exact
                to={`${routingAddresses.order.photos}/${props.orderId}`}
                data-testid="photos"
                className={isActive => `action-item ${isActive ? "active-item" : ""}`}
            >
                <ListItemButton>
                    <ListItemIcon className="item-icon">
                        <PhotosIcon/>
                    </ListItemIcon>
                    <ListItemText
                        primary={i18n.t("transportation.order.preview.actions.photos")}
                        className="item-text"
                    />
                </ListItemButton>
            </NavLink>
        );
    }

    function renderMobileMenu(): JSX.Element {
        return (
            <PopperMenu
                isOpen={openMenu}
                setOpen={(isOpen) => handleSetOpen(isOpen)}
                anchorEl={anchorRefUserMenu.current}
                testId="mobile-menu"
                className={`${className}-menu`}
                placement="top-end"
            >
                {userStore.displayOrderStatus && !isRelationTypeWithoutDepo && !isTicket && (
                    <MenuItem className="menu-item-wrapper">
                        <span
                            className="menu-item"
                            onClick={() => {
                                setOpenMenu(false);
                            }}
                            data-testid="status"
                        >
                            {renderStatusMenu()}
                        </span>
                    </MenuItem>
                )}
                <MenuItem className="menu-item-wrapper">
                    <span
                        className="menu-item"
                        onClick={() => {
                            setOpenMenu(false);
                        }}
                        data-testid="status"
                    >
                        {renderDetailsMenu()}
                    </span>
                </MenuItem>
                {!isTicket && userStore.displayTcr && !isRelationTypeWithoutDepo && (
                    <MenuItem className="menu-item-wrapper">
                        <span
                            className="menu-item"
                            onClick={() => {
                                setOpenMenu(false);
                            }}
                            data-testid="status"
                        >
                            {renderTcrMenu()}
                        </span>
                    </MenuItem>
                )}
                {userStore.displayNotifications &&  (
                    <MenuItem className="menu-item-wrapper">
                        <span
                            className="menu-item"
                            onClick={() => {
                                setOpenMenu(false);
                            }}
                            data-testid="status"
                        >
                            {renderMessagesMenu()}
                        </span>
                    </MenuItem>
                )}
                {userStore.displayOrderPhotos && !isTicket && (
                    <MenuItem className="menu-item-wrapper">
                        <span
                            className="menu-item"
                            onClick={() => {
                                setOpenMenu(false);
                            }}
                            data-testid="status"
                        >
                            {renderPhotosMenu()}
                        </span>
                    </MenuItem>
                )}
            </PopperMenu>
        );
    }

    function handleSetOpen(isOpen: boolean): void {
        setOpenMenu(isOpen);
    }

    return (
        <div className={`${className}-actions`}>
            <div className="top-menu">
                <NavLink
                    to={goBackAddress}
                    data-testid="go-back"
                >
                    <Button
                        variant="outlined"
                        text={isTicket ? ticketGoBackText : orderGoBackText}
                        type="secondary"
                        className="go-back-button"
                        startIcon={<GoBackIcon/>}
                    />
                </NavLink>

                {isTablet && (
                    <MenuButton
                        className="button secondary menu-button"
                        onClick={() => {
                            setOpenMenu(!openMenu);
                        }}
                        ref={anchorRefUserMenu}
                    >
                        {i18n.t("menu")}
                        {openMenu ?
                            <ExpandLessIcon className="expand-icon" fontSize="small"/> :
                            <ExpandMoreIcon className="expand-icon" fontSize="small"/>
                        }
                    </MenuButton>
                )}
                {renderMobileMenu()}

            </div>

            {!isTablet && (
                <div className={`${className}-menu`}>
                    {userStore.displayOrderStatus && !isRelationTypeWithoutDepo && !isTicket && renderStatusMenu()}
                    {renderDetailsMenu()}
                    {!isTicket && userStore.displayTcr && !isRelationTypeWithoutDepo && renderTcrMenu()}
                    {userStore.displayNotifications && renderMessagesMenu()}
                    {userStore.displayOrderPhotos && !isTicket && renderPhotosMenu()}
                </div>
            )}
        </div>
    );
}

export default withRouter(TransportationActions);
